var _line, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPins(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 37,
    viewBox: "0 0 25 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: -1,
    x2: 12,
    y2: -1,
    transform: "matrix(1.31134e-07 1 1 -1.31134e-07 13 24)",
    stroke: "#A9A9A9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.5,
    cy: 12.5,
    rx: 12.5,
    ry: 12.5,
    transform: "matrix(-1 8.74228e-08 8.74228e-08 1 25 0)",
    fill: "#6550BC"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.5,
    cy: 12.5,
    rx: 12.5,
    ry: 12.5,
    transform: "matrix(-1 8.74228e-08 8.74228e-08 1 25 0)",
    fill: "#F3E8E8"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.5,
    cy: 9.5,
    rx: 9.5,
    ry: 9.5,
    transform: "matrix(-1 8.74228e-08 8.74228e-08 1 22 3)",
    fill: "#FFB8B8"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.5,
    cy: 9.5,
    rx: 9.5,
    ry: 9.5,
    transform: "matrix(-1 8.74228e-08 8.74228e-08 1 22 3)",
    fill: "#E8D4D4"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.5,
    cy: 6.5,
    rx: 6.5,
    ry: 6.5,
    transform: "matrix(-1 8.74228e-08 8.74228e-08 1 19 6)",
    fill: "#FFB8B8"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.5,
    cy: 6.5,
    rx: 6.5,
    ry: 6.5,
    transform: "matrix(-1 8.74228e-08 8.74228e-08 1 19 6)",
    fill: "#FF0000"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPins);
export default __webpack_public_path__ + "static/media/pins.1e2e376e17f07e1b8466818270d8abf0.svg";
export { ForwardRef as ReactComponent };